import { Link, useLocation } from 'react-router-dom';
import { buttonVariants } from '@/components/ui/Button';

/**
 * 404 innerhalb der AppShell — Sidebar und Topbar bleiben stehen, damit die
 * Pflegekraft aus dem Fehler heraus weiterarbeiten kann.
 *
 * Ersetzt den frueheren stillen `<Navigate to="/dashboard">` des Catch-all:
 * der Redirect verschluckte Tippfehler und tote Links kommentarlos, die
 * Nutzerin landete ohne Erklaerung auf einer anderen Seite.
 *
 * Die aufgerufene Adresse wird mit angezeigt — bei einem vertippten oder
 * abgeschnittenen Link ist das der schnellste Hinweis. React escaped den Wert;
 * er steht ohnehin schon in der Adresszeile.
 */
export default function NotFound() {
    const { pathname } = useLocation();

    return (
        <div className="flex h-full flex-col items-center justify-center gap-8 py-10 text-center">
            <img
                src="/page-not-found.svg"
                alt=""
                width={280}
                height={222}
                /* Die Illustration ist fuer helle Flaechen gezeichnet und wirkt
                   auf dem dunklen Canvas sonst wie ein weisser Block. */
                className="h-auto w-[min(280px,70vw)] dark:opacity-75"
            />

            <div>
                <p className="text-xs font-medium uppercase tracking-[0.12em] text-neutral-500 dark:text-neutral-400">
                    Fehler 404
                </p>
                <h1 className="mt-3 text-3xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
                    Diese Seite gibt es nicht.
                </h1>
                <p className="mx-auto mt-3 max-w-[46ch] text-sm text-neutral-600 dark:text-neutral-300">
                    Vielleicht ist der Link veraltet oder die Adresse enthält einen Tippfehler.
                </p>
                <p className="mt-4">
                    <code className="inline-block max-w-full break-all rounded-lg bg-neutral-100 px-2.5 py-1.5 font-mono text-xs text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
                        {pathname}
                    </code>
                </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3">
                <Link to="/dashboard" className={buttonVariants({ variant: 'primary' })}>
                    Zum Dashboard
                </Link>
                <button
                    type="button"
                    onClick={() => window.history.back()}
                    className={buttonVariants({ variant: 'outline' })}
                >
                    Zurück
                </button>
            </div>
        </div>
    );
}
